export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7303.42cb3e05.jpg";